//node-modules
import { createContext, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
// common
import { Common } from "../../common/src/index";
//src
import NavBar from "../components/NavBar";
import ProjectList from "../components/Home/ProjectList";
import MenuButton from "../components/Home/MenuButton";
import "../../css/buttonTheme.css";
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Grid,
  styled,
  useTheme,
} from "@mui/material";
import Clusterings from "../components/Utility/Clusterings";
import "../locales/i18n";
import { config } from "../config/config";

// mui
import { makeStyles } from "@material-ui/core";

import { MsgSnackbar } from "../components/MsgSnackbar";
import { MsgErrSnackbar } from "../components/MsgErrSnackbar";
import { createSearchParams, Navigate, useLocation } from "react-router-dom";
import MsgWarnSnackbar from "../components/MsgWarnSnackbar";
import { HeaderFilter } from "../components/Home/HeaderFilter";
import { ProjectUserList } from "../../common/src/modules";
import { FilterDate } from "../components/Home/parts/FilterDate";
import { convertStatusStr, fetchProjectList } from "../api/project";
import GroupToggleButton from "../components/Home/parts/GroupToggleButton";
import SearchResult from "../components/Home/parts/SearchResult";
import { fetchUserLicense } from "../api/user";
import { UserSiteContext } from "../..";

export type testContextType = {
  isDelete: boolean;
  setIsDelete: React.Dispatch<React.SetStateAction<boolean>>;
  getProjectList?: (abortController: AbortController) => void;
};

export const deleteContext = createContext<testContextType>({
  isDelete: false,
  setIsDelete: () => {},
  getProjectList: (abortController: AbortController) => {},
});

export const enum EGroup {
  YEAR = "year",
  MONTH = "month",
  DAY = "day",
}

const Home = () => {
  const location = useLocation();

  /**
   * 保持するプロジェクトのデータ構造
   * >> プロジェクトが分割・絞り込みされていく >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
   * (All)         (folder)                     (filtered)           (clustering)
   * projectList -- folderProjectList -- filterdProjectList -- displayProjects[date1]
   *                                                            |- …
   * <-不変-------> <-可変------------------------------------------------------------>
   */
  const { t, i18n } = useTranslation();
  document.title = t("LIST_PROJECT");

  const { userInfo, userList, jobsiteList } = useContext(UserSiteContext);

  // check
  const [projectList, setProjectList] = useState<Common.Project[]>([]);
  const [displayProjects, setDisplayProjects] = useState<{
    [name: string]: [Common.Project];
  }>({});
  const [selectProject, setSelectProject] = useState<Common.Project[]>([]);

  const [group, setGroup] = useState<EGroup>(EGroup.MONTH); // sep, alignment -> group
  const [numHits, setNumHits] = useState<number>(0);
  const [numTotal, setNumTotal] = useState<number>(0);

  // Snackbar
  const [errorSnackbar, setErrorSnackbar] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [snackbar, setSnackbar] = useState(false);
  const [msg] = useState("");
  //プロジェクト削除有効化フラグ
  const [isDelete, setIsDelete] = useState(false);
  //language
  const [isLanguage, setLanguage] = useState<boolean>(false);
  //　ユーザー情報
  // 警告
  const [openWarnig, setOpenWarning] = useState<boolean>(false);
  const [msgWarning, setMsgWarning] = useState<string>("");

  const [openLicenseDialog, setOpenLicenseDialog] = useState(false);

  const [isARAvailable, setIsARAvailable] = useState<boolean>(false);

  /** useEffect */
  useEffect(() => {
    // license check
    const hasLicense = CheckLicense();
    if (!hasLicense) return;
  }, []);

  useEffect(() => {
    if (i18n.language === "ja") setLanguage(true);
    else setLanguage(false);
  }, [i18n.language]);

  useEffect(() => {
    FireGA(userInfo);
  }, [userInfo]);

  useEffect(() => {
    const controller = new AbortController();
    getProjectList(controller);
    return () => {
      controller.abort();
    };
  }, [location.search, location.pathname]);

  const FireGA = (uInfo: Common.LandlogNecessaryUserInfo) => {
    const { dataLayer } = window;
    const areAllNotNull = (vals: any[]): boolean => {
      return vals.every((val) => val !== null && val !== undefined);
    };
    if (areAllNotNull([uInfo?.corporationId, uInfo?.userId])) {
      dataLayer.push({
        sc_corporation_id: uInfo?.corporationId,
        sc_user_id: uInfo?.userId,
      });

      dataLayer.push({
        event: "sc_open",
      });
    }
  };

  const CheckLicense = async () => {
    let hasLicense = false;
    try {
      const data = await fetchUserLicense();
      const landlogLicenseStatus: Common.LandlogLicenseStatus = data;
      console.log(data);
      const numOfLicenses = landlogLicenseStatus.numOfLicenses;
      setIsARAvailable(landlogLicenseStatus.isARAvailable);
      if (config.licenseCheck) {
        if (1 <= numOfLicenses) {
          hasLicense = true;
        } else if (0 < numOfLicenses) {
          hasLicense = true;
          setOpenLicenseDialog(true);
        } else {
          throw new Error();
        }
      }
    } catch {
      if (config.licenseCheck === true) {
        setErrorSnackbar(true);
        setErrorMsg(t("LICENSE_ERROR"));
        setTimeout(function () {
          window.location.href = `${config.serverHost}/login?type=web`;
        }, 2000);
      }
    } finally {
      return hasLicense;
    }
  };

  const handleCloseLicenseDialog = () => {
    setOpenLicenseDialog(false);
  };

  const getProjectList = async (controller: AbortController) => {
    try {
      // if location.search don't have any search params, don't call api
      if (!location.search) return;

      const params = new URLSearchParams(location.search);
      const statusid = params.get("status");
      const userid = params.get("userid");
      const jobsiteid = params.get("jobsiteid");
      const searchstr = params.get("search");
      const rtk = !params.get("rtk") ? 2 : params.get("rtk") === "true" ? 1 : 0;
      const remove = !params.get("remove") ? false : true;
      const from = params.get("from");
      const to = params.get("to");
      const data = await fetchProjectList(controller, {
        status: convertStatusStr(statusid),
        userId: userid !== "all" && userid,
        jobsiteId: jobsiteid,
        searchStr: searchstr,
        isRTK: rtk,
        isPointRemoved: remove,
        from: from,
        to: to,
      });
      setProjectList(data.projects);
      setNumHits(data.hitsTotal);
      setNumTotal(data.total);
      setDisplayProjects(Clusterings.clusterByDate(data.projects, group));
    } catch (e) {
      console.error("Error: " + e);
    }
  };

  //スナックバー機能
  const handleErrorSnackbarClose = async () => {
    setErrorSnackbar(false);
  };
  const handleSnackbarClose = async () => {
    setSnackbar(false);
  };

  // 警告
  const handleWarnCloseSnackbar = () => {
    setOpenWarning(false);
  };

  const theme = useTheme();

  const customColor = {
    color: theme.palette.base.contrast,
    background: theme.palette.base.main,
  };

  const customDialogBackgroundColor = {
    color: theme.palette.base.dialogBackground,
  };

  const customBackgroundStyles = {
    background: theme.palette.base.modal,
  };

  // MuiPaper-root css
  const useStyles = makeStyles(() => ({
    root: {
      "&.MuiPaper-root,&.MuiPaper-elevation": {
        color: "#fff",
        backgroundcolor: "#121212",
      },
    },
  }));

  const classes = useStyles();

  // bodyのスタイルの上書き
  const useBodyStyles = makeStyles(() => ({
    body: {
      background: theme.palette.base.sub,
    },
  }));

  const classesBody = useBodyStyles();
  document.body.classList.add(classesBody.body);

  const cssStyles = makeStyles({
    dialogRoot: {
      "&.MuiTypography-root": { textAlign: "left", fontSize: "18px" },
    },
    btn1: {
      "&.MuiButtonBase-root": {
        height: "24px",
        width: "24px",
        color: customColor.color,
        float: "right",
        fontSize: "18px",
        margin: "0px",
        padding: "0px",
        position: "absolute",
        right: "0px",
        outline: "none",
      },
    },
  });
  const userStyle = cssStyles();

  const CustomButton = styled(Button)({
    background: theme.palette.primary.main,
    boxShadow: "none",
    color: "#FFFFFF",
    height: "42px",
    width: "250px",
    outline: "none",
    textTransform: "none",
    "&:hover": {
      background: theme.palette.primary.main,
      boxShadow: "none",
    },
  });

  const createFilterUserList = (
    userList: ProjectUserList[],
    additions?: { value: string; label: string }[]
  ) => {
    const convertedList = userList.map((item) => {
      return { value: item.userId, label: item.name };
    });
    const filteredList = convertedList.filter((item) => {
      return item.label;
    });
    return [...additions, ...filteredList];
  };

  const createFilterJobsiteList = (
    jobsiteList: Common.LandlogJobSite[],
    additions?: { value: string; label: string }[]
  ) => {
    const convertedList = jobsiteList.map((item) => {
      return { value: item.id, label: item.name };
    });
    const filteredList = convertedList.filter((item) => {
      return item.label;
    });
    return [...additions, ...filteredList];
  };

  const search = window.location.search;
  const params = new URLSearchParams(search);
  let init = true;
  // 検索条件がなければuserIDがデフォルト
  const withoutParams = () => {
    return (
      !params.get("status") &&
      !params.get("userid") &&
      !params.get("jobsiteid") &&
      !params.get("search") &&
      !params.get("rtk") &&
      !params.get("remove") &&
      !params.get("from") &&
      !params.get("to")
    );
  };

  return withoutParams() ? (
    <>
      <Navigate
        to={{
          pathname: "/",
          search: createSearchParams({
            userid: userInfo?.userId,
          }).toString(),
        }}
      />
    </>
  ) : (
    <div className={`${classes.root}`}>
      <Grid
        container
        sx={{
          position: "sticky",
          top: "0px",
          zIndex: "10",
          // boxShadow:
          // "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
        }}
      >
        <NavBar userInfo={userInfo} />
        <Grid container sx={{ ...customColor, padding: "4px 16px" }}>
          <Grid
            item
            xs={11}
            sx={{
              display: "flex",
              alignItems: "flex-end",
              gap: "var(--space-space--8, 8px)",
              flexWrap: "wrap",
            }}
          >
            <HeaderFilter
              userList={createFilterUserList(userList, [
                { value: "all", label: t("ALL") },
              ])}
              jobsiteList={createFilterJobsiteList(jobsiteList, [
                { value: "all", label: t("ALL") },
              ])}
              isARAvailable={isARAvailable}
            />
          </Grid>
          <Grid
            item
            xs={1}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              height: "48px",
              gap: "var(--space-space--8, 8px)",
            }}
          >
            <deleteContext.Provider
              value={{ isDelete, setIsDelete, getProjectList }}
            >
              <MenuButton
                userInfo={userInfo}
                projectID={selectProject}
                setErrorSnackbar={setErrorSnackbar}
                setErrorMsg={setErrorMsg}
                setOpenWarning={setOpenWarning}
                setMsgWarning={setMsgWarning}
                isARAvailable={isARAvailable}
              />
            </deleteContext.Provider>
          </Grid>
        </Grid>
      </Grid>
      <Grid container>
        <Grid container className="Bottom-bar" sx={{ padding: "16px 16px" }}>
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              height: "48px",
              gap: "var(--space-space--8, 8px)",
            }}
          >
            <SearchResult hits={numHits} total={numTotal} />
          </Grid>
          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              height: "48px",
              gap: "var(--space-space--8, 8px)",
            }}
          >
            <FilterDate />
            <GroupToggleButton
              value={group}
              onChange={(value) => {
                setGroup(value);
                setDisplayProjects(
                  Clusterings.clusterByDate(projectList, value)
                );
              }}
            />
          </Grid>
        </Grid>
        <deleteContext.Provider
          value={{ isDelete, setIsDelete, getProjectList }}
        >
          <ProjectList
            displayProjects={displayProjects}
            selectProject={selectProject}
            setSelectProject={setSelectProject}
            isLanguage={isLanguage}
            userList={userList}
            jobsiteList={jobsiteList}
            setErrorSnackbar={setErrorSnackbar}
            setErrorMsg={setErrorMsg}
            setOpenWarning={setOpenWarning}
            setMsgWarning={setMsgWarning}
            isARAvailable={isARAvailable}
          />
        </deleteContext.Provider>
      </Grid>
      <Dialog
        open={openLicenseDialog}
        onClose={handleCloseLicenseDialog}
        PaperProps={{
          style: {
            width: "581px",
            // height: "500px",
            boxShadow: "none",
            border: "1px solid #44444F",
            ...customBackgroundStyles,
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: customDialogBackgroundColor.color,
            },
          },
        }}
      >
        <DialogTitle className={userStyle.dialogRoot}>
          {t("LICENSE_ALERT")}
          <Button className={userStyle.btn1} onClick={handleCloseLicenseDialog}>
            ×
          </Button>
          <div style={{ borderBottom: "1px solid" }} />
        </DialogTitle>
        <DialogContent>
          <DialogTitle style={{ fontSize: "16px" }}>
            {t("LICENSE_ALERT_CONTENT_1")}
          </DialogTitle>
          <DialogTitle style={{ fontSize: "16px" }} textAlign={"center"}>
            <a
              target="_blank"
              style={{ color: customColor.color }}
              href={process.env.REACT_APP_SC_LICENSE_URL}
            >
              {t("LICENSE_ALERT_CONTENT_2")}
            </a>
          </DialogTitle>
          <DialogTitle style={{ fontSize: "16px" }}>
            {t("LICENSE_ALERT_CONTENT_3")}
          </DialogTitle>
          <DialogActions style={{ display: "flex", justifyContent: "center" }}>
            <CustomButton
              onClick={handleCloseLicenseDialog}
              variant="contained"
              size="small"
              style={{
                borderRadius: "0px",
              }}
            >
              {t("CLOSE")}
            </CustomButton>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <MsgSnackbar open={snackbar} onClose={handleSnackbarClose} msg={msg} />
      <MsgErrSnackbar
        open={errorSnackbar}
        onClose={handleErrorSnackbarClose}
        msg={errorMsg}
      />
      <MsgWarnSnackbar
        open={openWarnig}
        onClose={handleWarnCloseSnackbar}
        msg={msgWarning}
      />
    </div>
  );
};

export default Home;
